import { render, staticRenderFns } from "./KeypalCard.vue?vue&type=template&id=12d74614&scoped=true&"
import script from "./KeypalCard.vue?vue&type=script&lang=js&"
export * from "./KeypalCard.vue?vue&type=script&lang=js&"
import style0 from "./KeypalCard.vue?vue&type=style&index=0&id=12d74614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d74614",
  null
  
)

export default component.exports